import { StyledTableCell, StyledTableRow } from 'ui/StyledTable';
import { useNavigate } from 'react-router';
import { ItemWithId } from 'components/HMRC/data/types';
import React from 'react';
import { TEasTableRowProps } from './types';
import { ETableStructureType, ETableStructureVerticalAlign } from '../types';
import { EasTableValue } from './EasTableValue';
import { COLORS } from '../../../services/constants/colors';

export const EasTableRow = <T extends ItemWithId>({
	item,
	setSelectedRow,
	index,
	selectedRow,
	tableStructure,
	handleAction,
	checkedRow = false,
	handleLink,
	highlightedRow,
	disabledRowFn,
}: TEasTableRowProps<T>) => {
	const navigate = useNavigate();
	const isRowDisabled = disabledRowFn?.(item) === true;

	const linkSelector = tableStructure.find((i) => i.type === ETableStructureType.LINK)?.selector;

	const handleLinkClick = () => {
		const linkSelector = tableStructure.find((i) => i.type === 'link')?.selector;
		if (linkSelector) {
			const id = linkSelector !== 'actions' ? item?.[linkSelector] : item?.id;
			if (handleLink) {
				handleLink(id as number);
			} else navigate(String(id));
		}
	};

	const handleActionStopPropagation = (
		event: React.MouseEvent<HTMLButtonElement>,
		id: number,
		type: string,
	) => {
		event.stopPropagation();
		handleAction(id, type);
	};

	return (
		<StyledTableRow
			sx={{
				'&:last-child td, &:last-child th': { border: 0 },
				background: checkedRow
					? COLORS.TABLE_ROW_HOVER
					: highlightedRow === index
						? '#0362937a!important'
						: selectedRow === index
							? COLORS.TABLE_ROW_HOVER
							: 'auto',
				opacity: isRowDisabled ? 0.5 : 1,
				p: '0px',
				m: '0px',
				cursor: linkSelector ? 'pointer' : 'default',
			}}
			onClick={handleLinkClick}
			onMouseOver={() => setSelectedRow(index)}
		>
			{tableStructure?.map((filter, filterIndex) => {
				if (filter.show === false) return null;
				return (
					<StyledTableCell
						key={`${String(filter?.selector)}-${filterIndex}`}
						align={filter?.align ?? 'center'}
						colSpan={filter?.colSpan ?? 1}
						sx={{
							padding: '4px 8px 4px 8px',
							verticalAlign: filter?.verticalAlign ?? ETableStructureVerticalAlign.MIDDLE,
							lineHeight: '1rem',
							maxWidth: '450px',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							position: 'relative',
							p: '4px!important',
							m: '0px',
						}}
					>
						<EasTableValue
							type={filter?.type}
							value={
								filter?.value
									? filter.value(item)
									: filter?.selector !== 'actions'
										? item?.[filter?.selector]
										: item?.id
							}
							tableStructureItem={filter}
							item={item}
							selectedRow={selectedRow}
							index={index}
							handleActionStopPropagation={handleActionStopPropagation}
							tooltip={filter?.tooltip ? filter.tooltip(item) : undefined}
						/>
					</StyledTableCell>
				);
			})}
		</StyledTableRow>
	);
};
